export default {
  metrics: {
    gs: {
      label: '可玩展示数',
      desc: '可玩素材展示的次数（重新试玩不计为展示）。',
      group: '可玩展示',
    },
    fi: {
      label: '首次交互数',
      scene_label: '场景首次交互数',
      desc: '用户首次触发点击、拖拽等交互行为，计为一次首次交互。',
      group: '首次交互',
    },
    ge: {
      label: '试玩结束数',
      desc: '用户到达结束场景或满足特定的结束条件，计为一次试玩结束。',
      group: '试玩结束',
    },
    vi: {
      label: '有效交互次数',
      desc: '用户触发游戏逻辑的交互行为数。',
    },
    vi_avg: {
      label: '平均有效交互次数',
      desc: '平均每次展示中，用户触发游戏逻辑的交互行为数',
    },
    wc: {
      label: '关闭素材数',
      desc: '用户触发关闭按钮的次数。',
    },
    install: {
      label: '跳转数',
      scene_label: '场景跳转数',
      desc: '用户在素材中跳转到其他url或跳转应用商店，计为一次跳转。',
    },
    replay: {
      label: '重新试玩数',
      desc: '用户触发过重新试玩，计为一次重新试玩',
    },
    fi_time: {
      label: '首次交互时长',
      desc: '用户从素材展示到首次交互的平均时长（未触发首次交互的不计入）。',
    },
    ge_time: {
      label: '试玩时长',
      desc: '用户从素材展示到试玩结束的平均时长（未触发试玩结束的不计入）。',
    },
    loss: {
      label: '场景流失数',
      desc: '用户流失且没有跳转到其他url或应用商店的数量。',
    },
    loss_after_fi: {
      label: '交互后流失数',
      scene_label: '场景交互后流失数',
      desc: '用户在交互后流失且没有跳转到其他url或应用商店的数量。',
    },
    loss_playing: {
      label: '试玩时流失数',
      desc: '用户在试玩过程中流失且没有跳转到其他url或应用商店的数量。',
    },
    loss_ending: {
      label: '试玩结束流失数',
      desc: '用户在试玩结束时流失且没有跳转到其他url或应用商店的数量。',
    },
    loss_fi: {
      label: '交互前流失数',
      scene_label: '场景交互前流失数',
      desc: '用户触发交互行为前流失的数量。',
    },
    loss_rate: {
      label: '场景流失率',
      desc: '场景流失数/场景到达数',
    },
    loss_fi_rate: {
      label: '交互前流失率',
      desc: '交互前流失数/可玩展示数',
      scene_label: '场景交互前流失率',
      scene_desc: '场景交互前流失数/场景到达数',
    },
    loss_after_fi_rate: {
      label: '交互后流失率',
      desc: '交互后流失数/可玩展示数',
      scene_label: '场景交互后流失率',
      scene_desc: '场景交互后流失数/场景到达数',
    },
    loss_playing_rate: {
      label: '试玩时流失率',
      desc: '试玩时流失数/可玩展示数',
    },
    loss_ending_rate: {
      label: '试玩结束流失率',
      desc: '试玩结束流失数/可玩展示数',
    },
    install_rate: {
      label: '跳转率',
      desc: '跳转数/可玩展示数',
      scene_label: '场景跳转率',
      scene_desc: '场景跳转数/场景到达数',
    },
    install_playing_rate: {
      label: '试玩时跳转率',
      desc: '试玩时跳转数/可玩展示数',
    },
    install_ending_rate: {
      label: '试玩结束跳转率',
      desc: '试玩结束跳转数/可玩展示数',
    },
    fi_rate: {
      label: '首次交互率',
      desc: '首次交互数/可玩展示数',
      scene_label: '场景首次交互率',
      scene_desc: '场景首次交互数/场景到达数',
    },
    ge_rate: {
      label: '试玩结束率',
      desc: '试玩结束数/可玩展示数',
    },
    rp_rate: {
      label: '重新试玩率',
      desc: '重新试玩数/可玩展示数',
    },
    reach: {
      label: '场景到达数',
      desc: '用户到达当前场景的次数。',
    },
    go_next: {
      label: '跳转其他场景数',
      desc: '用户从当前场景跳转到其他场景的次数。',
    },
    go_next_rate: {
      label: '跳转其他场景率',
      desc: '跳转其他场景数/场景到达数',
    },
    stay_time: {
      label: '场景停留时长',
      desc: '用户在该场景停留的平均时长（未跳转到其他场景的不计入）。',
    },
    install_playing: {
      label: '试玩时跳转数',
      desc: '用户在试玩过程中跳转其他url或应用商店的数量。',
    },
    install_ending: {
      label: '试玩结束跳转数',
      desc: '用户在试玩结束后跳转其他url或应用商店的数量。',
    },
    ge_auto: {
      label: '自动试玩结束数',
      desc: '由于素材本身或投放平台逻辑自动触发，非用户手动触发的试玩结束次数。',
    },
    ge_manual: {
      label: '手动试玩结束数',
      desc: '用户手动触发的试玩结束次数。',
    },
    install_auto: {
      label: '自动跳转数',
      desc: '由于素材本身或投放平台逻辑自动触发，非用户手动触发的跳转数量。',
    },
    install_manual: {
      label: '手动跳转数',
      desc: '用户手动触发的跳转数量。',
    },
    title: '指标',
  },
  metricsType: {
    action: '交互指标',
    translate: '转化指标',
    loss: '流失指标',
    custom: '自定义埋点指标',
    placeAds: '投放指标',
  },
  metricsGroupType: {
    ads: '投放数据',
    pl: '交互数据',
  },
  adsMetrics: {
    cost: {
      label: '花费',
    },
    click: {
      label: '点击数',
    },
    impression: {
      label: '展示数',
    },
    install: {
      label: '转化数',
    },
    ctr: {
      label: '点击率',
      desc: '点击数/展示数',
    },
    cvr: {
      label: '转化率',
      desc: '转化数/点击数',
    },
    ivr: {
      label: '展示转化率',
      desc: '转化数/展示数',
    },
    cpi: {
      label: '转化成本',
      desc: '花费/转化数',
    },
    cpm: {
      label: '千次展示成本',
      desc: '花费/（展示*1000）',
    },
    cpc: {
      label: '点击成本',
      desc: '花费/点击数',
    },
    date_cost: {
      label: '日均花费',
    },
    date_impression: {
      label: '日均展示数',
    },
    date_click: {
      label: '日均点击数',
    },
    date_install: {
      label: '日均转化数',
    },
  },
  breakdowns: {
    ad_output_type: '广告呈现类型',
    material_name: '广告平台素材名称',
    material_type: '素材类型',
    package_name: '投放产品',
    material_source: '素材来源',
    template_id: '可玩模板',
    campaign_id: '广告系列',
    adset_id: '广告组',
    basic_id: '创意ID及名称',
    fingerprint: 'Playturbo素材名称及指纹',
    fingerprint_desc:
      '部分素材没有Playturbo素材名称时，取广告平台素材名称进行展示，若无广告平台素材名称，则取素材指纹进行展示',
    ad_id: '广告',
    period: '日期',
    traffic_type: '广告平台',
    platform: '操作系统',
    country_code: '投放地区',
    project_id: '项目名称及ID',
    ad_type: '广告类型',
    mid: '素材id',
    product_id: '关联产品',
    publish_time: '生成时间',
    scene: '场景',
    title: '维度',
    onlyMintegralTip: '该字段仅当广告平台为Mintegral时可用。',
    onlyUnityTip: '该字段仅当广告平台为Unity时可用。',
    tooltipAdDataTips: {
      datarange: '需绑定广告账号，且试玩素材数据范围不为：不拉取',
      mars: '需允许可玩素材添加埋点',
    },
    onlyIronsourceTip: {
      noSupport: 'Ironsource暂不支持',
    },
  },
  title: '创意洞察',
  overview: {
    title: '投放数据总览（内测）',
    desc: '该页面为您提供广告账号的投放数据概览。您可以快速了解各个广告账号、不同素材类型的广告表现。',
    data: {
      title: '近7日数据',
      account: '账号',
      accountAll: '全部',
      accountBtn: '修改关联广告主',
      adData: '投放数据',
      plData: '素材数据',
      impression: '曝光素材数',
      impressionTips: '近7天展示数大于0的素材数量',
      minimumQuantity: '起量素材数',
      minimumQuantityTips: '近7天展示数大于3000的素材数量',
    },
    chart: {
      title: '对比分析',
      detailTitle: '详细数据',
      detailTooltip:
        '一次广告展示包含多个素材时，展示数、点击数、安装数、花费在每个素材上都会被计一份数据',
    },
    single: {
      title: '单个产品素材情况',
    },
    overall: {
      title: '整体素材情况',
      subTitle: {
        all: '以下 4 个图表为「创意」维度。仅包含Playturbo产出可玩素材。',
        mtg: '以下 4 个图表为「广告素材」维度。包含广告账号内的所有可玩素材。',
      },
      tooltips: {
        all: '如需分析广告账号内所有素材，请前往单个渠道。',
      },
    },
    material: {
      source: {
        title: '素材来源对比',
      },
      pv: {
        title: '素材起量情况',
      },
      install: {
        title: '素材转化情况',
      },
      pl: {
        title: '素材情况',
      },
      alldata: {
        title: '全部数据',
      },
    },
  },
  tips: {
    materialTypeDisabled: '进行素材类型筛选后才可查看该维度',
    selectedReason: '当前维度不支持查看该指标，请重新选择。',
    filteredReason: '当前筛选项不支持查看该指标，请重新选择。',
    daterange: {
      max: '选择日期超过指定最大{max}天数。',
    },
  },
  chart: {
    breakdown: {
      ruleTips: '最多1个维度，请前往自定义报表更改。',
    },
    filter: {
      day: {
        label: '按天',
        desc: '按天汇总',
      },
      week: {
        label: '按周',
        desc: '按自然周汇总',
      },
      month: {
        label: '按月',
        desc: '按自然月汇总',
      },
    },
    exceedTip: '* 当前周期内汇总指标数据，从大到小排序选取前 {max} 进行展示',
  },
  tz: {
    label: '时区',
    all: {
      tip: '不同广告平台对应时区不同，{text}',
      tipBtnText: '点击查看详情',
    },
    mtg: {
      tip: '跟随主账号的时区',
    },
    updateTime: '更新时间',
    updateTimeTip: '{time} 更新前一天数据',
  },
  material: {
    title: '可玩素材分析',
    dataAnalysis: {
      title: '详细数据',
      filterDialog: {
        btnText: '自定义报表',
        filter: '筛选',
        column: '自定义列',
      },
    },
    detailTitle: '可玩素材交互分析',
    detailTitleDesc: '分析用户在各个场景及自定义埋点的到达、流失与转化情况。',
    analyze: {
      tab: {
        scene: '场景分析',
        journey: '用户旅程分析',
      },
      projectType: {
        subs: '订阅项目',
        custom: '定制项目',
      },
    },
    DetailData: '详细数据',
    playable: {
      description:
        '基于可玩素材的投放数据和埋点数据，为您提供了多维度的素材分析。您可以通过这些数据洞察用户行为，评估素材效果，并为下一步素材优化提供依据。',
      interaction: {
        description:
          '基于可玩素材的埋点数据，为您提供用户旅程及场景维度的用户交互分析。您可以通过这些数据定位素材的潜在优化点。',
      },
    },
    descriptionTooltip:
      '埋点数据仅供参考，用于分析素材内用户交互行为，并不代表最终效果。',
    descTip: '埋点数据仅供参考，用于分析素材内用户交互行为，并不代表最终效果。',
    unsupportAnalyze: {
      noaccess: '暂无权限',
      noscene: '该素材未区分场景，暂不支持分析',
    },
    projectFilter: {
      select: '请选择',
      empty: '暂未选择创意版本',
    },
    preview: {
      title: '预览',
      selectText: '开始预览',
      sceneName: '场景{n}',
      sceneFrom: '从 场景{fromScene} 开始预览',
      sceneDlLoss: '场景分布',
    },
  },
  event: {
    title: '事件分析',
    desc: '收集用户在试玩过程中触发的多种事件，并提供多维度、多种图表的事件数据分析。',
    descTip: '埋点数据仅供参考，用于分析素材内用户交互行为，并不代表最终效果。',
    overview: {
      title: '近7日数据',
      subTitle: '本周期展示素材数: {count}',
      fi_time_average: '首次交互时长',
      ge_time_average: '试玩时长',
      ge_manual_rate: '交互后结束率',
      adsData: '投放数据',
      adsDataTips: {
        all: '所有授权广告账号下，试玩素材投放数据汇总。',
        mtg: '{trafficType}授权广告账号下，试玩素材投放数据汇总。',
      },
      plData: '可玩交互数据',
      plDataTips: {
        all: '该Playturbo账号产出的 所有试玩素材交互数据汇总。',
        mtg: '该Playturbo账号产出的 {trafficType}试玩素材交互数据汇总。',
        other:
          '该 Playturbo 账号下产出的所有在该渠道投放的可玩素材交互数据的汇总。',
      },
    },
    trend: {
      title: '趋势分析',
      subTitle: '所选数据指标在指定时间段内的变化趋势。',
      unknown: '未知',
      topTips: '当前周期内汇总指标数据，从大到小排序选取展示的折线。',
      filterDialog: {
        btnText: '自定义图表',
        filter: '筛选',
        mab: '指标维度',
      },
    },
    detail: '详细数据',
  },
  customColumn: {
    title: '自定义列',
    placeholder: '过滤列',
    materialRule: '请至少选择{num}个素材信息',
    metricsRule: '请至少选择 {num} 个指标',
    breakdownRule: '请至少选择 {num} 个维度',
    breakdownsRule: '请选择{min}-{max}个维度',
    materialInfo: '素材信息',
    materialInfoProduct: '素材制作信息',
    materialInfoPoint: '素材投放信息',
    selected: '已选择 {count} 列',
    clear: '清空',
    emptyData: '暂无数据',
    fixedMessage: '拖动到上方的列固定展示',
    cancel: '取消',
    confirm: '确定',
  },
  export: {
    title: '导出数据',
    message: '导出时间较长，请耐心等待。',
    error: '导出失败，请重新导出。',
  },
  blankTemplate: '空白制作',
  filter: {
    productNameOrId: '项目名称及ID',
    product_id: '项目ID',
    product_name: '项目名称',
    pleaseInput: '请输入',
    search: '搜索',
    inputProductId: '请输入关联产品',
    publish_time: '素材创建时间',
    pleaseSelect: '请选择',
    showTime: {
      first: '首次到达',
      all: '所有到达次数汇总',
    },
    adType: {
      rewardedVideo: 'Rewarded Video（激励视频广告）',
      interstitialVideo: 'Interstitial Video（视频类插屏广告）',
    },
    platform: {
      ios: 'iOS',
      android: 'Android',
    },
    adOutputType: {
      videoAndCommonEndcard: '视频+通用endcard',
      videoAndDynamicEndcard: '视频+动态endcard',
      videoAndPlayable: '视频+可玩',
      onlyVideo: '仅视频',
      onlyPlayable: '仅可玩',
      other: '其他',
    },
    trafficType: {
      all: '汇总',
    },
    materialType: {
      pl: '可玩',
      video: '视频',
      graphic: '图片',
      unknown: '未知',
    },
    materialSource: {
      playturboTemplate: 'Playturbo换肤',
      playsmart: 'Playturbo自由编辑',
      mws: 'MWS定制',
      adPlatform: '广告平台上传',
      unknown: '未知',
    },
    total: {
      filters: '筛选',
      columns: '列',
    },
  },
  table: {
    operation: '操作',
  },
  searchFilter: {
    clear: '清空',
    allFilter: '所有筛选',
    filter: '筛选',
    cancel: '取消',
    confirm: '确定',
  },
  ringRatio: '环比 {value}',
  journey: {
    title: '用户旅程分析',
    filter: {
      label: '所有筛选',
    },
    actions: {
      cancel: '取消',
      save: '展示旅程',
      edit: '编辑',
    },
    disabledEditTips: '该素材为模板制作/定制制作素材，无需手动配置用户旅程。',
  },
  searchEmpty: {
    tips: '无搜索结果',
  },
  searchForbidden: {
    tips: '清空搜索内容后才可选',
  },
}
